export default "__VITE_ASSET__CxehQ4ht__"